<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="车牌：" prop="licensePlate">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.licensePlate"
          placeholder="请输入车牌"
          size="small"
          :maxlength="18"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="车型：" prop="carModel">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.carModel"
          placeholder="请输入车型"
          size="small"
          :maxlength="24"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="核载人数：" prop="nuclearLoadNumber">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.nuclearLoadNumber"
          placeholder="请输入核载人数"
          size="small"
          :maxlength="18"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="车辆许可证:" prop="img">
        <head-portrait-up-load
          :imageUrl="ruleForm.img"
          @imageChange="imageChange"
        ></head-portrait-up-load>
      </el-form-item>
      <el-form-item label="负责人姓名：" prop="name">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.name"
          placeholder="请输入负责人姓名"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="负责人电话：" prop="phone">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.phone"
          placeholder="请输入负责人电话"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="负责人职务：">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.job"
          placeholder="请输入负责人职务"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item size="large">
        <el-button type="primary" size="small" @click="saveSubmit('ruleForm')"
          >提交</el-button
        >
        <el-button
          type="primary"
          size="small"
          plain
          @click="cencelSubmit('ruleForm')"
          >取消</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import HeadPortraitUpLoad from "@/components/HeadPortraitUpLoad";
export default {
  name: "SchoolBusAddOrEdit",
  components: {
    HeadPortraitUpLoad
  },
  props: {
    defaultData: {
      type: Object,
      default: {
        return: {}
      }
    },
    showBox: {
      type: Boolean,
      default: {
        return: false
      }
    }
  },
  computed: {
    personnelSex() {
      return this.$store.state.select.personnelSex;
    },
    personnelType() {
      return this.$store.state.select.personnelType;
    }
  },
  data() {
    var num = /^[0-9]*[1-9][0-9]*$/;
    var checkNum = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!num.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!reg.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    // 车牌号校验
    var plate = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
    var checkPlate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!plate.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      ruleForm: this.defaultData,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      rules: {
        licensePlate: [{ required: true, validator: checkPlate, trigger: "blur" }],
        carModel: [{ required: true, message: " ", trigger: "blur" }],
        nuclearLoadNumber: [
          { required: true, validator: checkNum, trigger: "blur" }
        ],
        name: [{ required: true, message: " ", trigger: "blur" }],
        phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        img: [{ required: true, message: " ", trigger: "change" }]
      }
    };
  },
  methods: {
    selectedAddDataDate() {
      this.ruleForm.age = this.$Common.calculationAges(this.ruleForm.birthday);
    },
    imageChange(src) {
      this.ruleForm.img = src || "";
    },
    //   提交
    saveSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("saveSubmit", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    //   取消
    cencelSubmit(formName) {
      this.$refs[formName].resetFields();
      this.$emit("cencelSubmit");
    }
  },
  watch: {
    showBox: function(val) {
      this.$refs.ruleForm.resetFields();
      if (val) {
        this.ruleForm = Object.assign({}, this.defaultData);
      } else {
        this.$refs.ruleForm.resetFields();
      }
    }
  }
};
</script>
